// extracted by mini-css-extract-plugin
export default {"add":"AddRate_add__tyEak","boxInput":"AddRate_boxInput__331D-","boxCur":"AddRate_boxCur__ML8t6"};